import { ListInsuranceResponse } from '../../types/plans/types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { get } from '../apiService';

export const getInsuranceList = async (
  payorNames?: string[]
): Promise<ListInsuranceResponse> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }

  const searchParams = new URLSearchParams({ customerId: customer });

  if (payorNames) {
    payorNames.forEach((payorName) => {
      if (payorName) {
        searchParams.append('payorNames', payorName);
      }
    });
  }

  const url = `resourceMatrix/insurance/list_insurance?${searchParams.toString()}`;
  return get<ListInsuranceResponse>(url);
};
